module.exports = __webpack_public_path__ + "img/zip_reference_icon.8dda0d7b.svg";